import service from '@/utils/server';

const modName='/md/configToxinSample/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const update = data => {
  return service({
    url: modName + 'update',
    method: 'post',
    data
  });
};

export const getDetailById = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/configToxinSample/api/index.js